import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=01f6cafb&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=01f6cafb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6cafb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f6cafb')) {
      api.createRecord('01f6cafb', component.options)
    } else {
      api.reload('01f6cafb', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=01f6cafb&scoped=true&", function () {
      api.rerender('01f6cafb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dLm6smQxWhd8/JS/comp/PopupBox.vue"
export default component.exports